/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RecordPorterHistoryFromJSON, RecordPorterHistoryToJSON } from './RecordPorterHistory';
export function GetLatestRecordPorterHistoryResponseDataFromJSON(json) {
    return GetLatestRecordPorterHistoryResponseDataFromJSONTyped(json, false);
}
export function GetLatestRecordPorterHistoryResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        recordPorterHistory: !exists(json, 'record_porter_history')
            ? undefined
            : RecordPorterHistoryFromJSON(json['record_porter_history'])
    };
}
export function GetLatestRecordPorterHistoryResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        record_porter_history: RecordPorterHistoryToJSON(value.recordPorterHistory)
    };
}
